/**
 *
 * @param input {array} Array of promises, but some promises can also be a array of promises. Just 1 level though
 * @return {array} flattened array of promises
 */
export const flattenArray = (input: Array<unknown> | Array<Array<unknown>>): Array<unknown> => {
  // Find the trailing number or it will match the empty string
  return input?.flat(Infinity) ?? [];
};
